module.exports = __webpack_public_path__ + "img/curve_line_icon.15fb5854.svg";